var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#F79D54",
    stroke: "#F79D54",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1212 7.80108C16.327 7.60891 16.6047 7.50076 16.8944 7.5C17.1841 7.49925 17.4624 7.60596 17.6693 7.79706C17.8762 7.98816 17.9949 8.2483 17.9998 8.52123C18.0048 8.79416 17.8955 9.05796 17.6957 9.25559L11.827 16.168C11.7262 16.2703 11.6045 16.3525 11.4691 16.4095C11.3338 16.4665 11.1877 16.4972 11.0394 16.4998C10.8912 16.5024 10.744 16.4768 10.6065 16.4245C10.469 16.3723 10.3442 16.2944 10.2393 16.1957L6.35093 12.5303C6.2426 12.4352 6.15571 12.3205 6.09545 12.193C6.03519 12.0656 6.00278 11.928 6.00017 11.7885C5.99756 11.649 6.02479 11.5105 6.08025 11.3811C6.1357 11.2517 6.21824 11.1342 6.32294 11.0356C6.42764 10.9369 6.55235 10.8591 6.68964 10.8069C6.82693 10.7546 6.97398 10.729 7.12203 10.7314C7.27007 10.7339 7.41607 10.7644 7.55132 10.8212C7.68657 10.878 7.80829 10.9599 7.90923 11.0619L10.9876 13.9613L16.0933 7.83156C16.1024 7.82083 16.1122 7.81065 16.1227 7.80108H16.1212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5383a3bf9cb9b82bbeab380035fd55b0.svg";
export { ForwardRef as ReactComponent };